import React, { useState, useEffect, useCallback } from "react";
import bible from "../../Assets/images/bible.jpeg";
import bgHolly from "../../Assets/images/IMG_3520.JPG.jpeg";
import Navbar from "../Sections/Navbar";
import { useFirebaseData } from "../../hooks/useFirebaseData";

const SlidingImages = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [images] = useState([bible, bgHolly]);
  const [isFading, setIsFading] = useState(false);
  const { data: bannerData, loading } = useFirebaseData('banner');
  const bannerContent = bannerData[0] || {};

  const nextSlide = useCallback(() => {
    setIsFading(true);
    setTimeout(() => {
      setCurrentIndex((currentIndex + 1) % images.length);
      setIsFading(false);
    }, 400);
  }, [currentIndex, images.length]);

  useEffect(() => {
    const timer = setInterval(nextSlide, 3000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="relative">
      <img
        src={images[currentIndex]}
        className={`object-cover object-center h-[900px] lg:h-full w-full ${
          isFading ? "opacity-30" : "opacity-100"
        } transition-opacity duration-1000`}
        alt={`Slide ${currentIndex}`}
      />
      <div className="absolute z-20 px-12 top-64 md:bottom-64 w-full flex flex-col items-center justify-center">
        <div className="text-white flex gap-3 font-[roboto] font-bold">
          <div className="h-[1px] w-32 bg-white mt-[10px] hidden md:block"></div>
          <div>{bannerContent.churchName || "Eglise Evangelique des Amis au Rwanda (EEAR)"}</div>
          <div className="h-[1px] w-32 bg-white mt-[10px] hidden md:block"></div>
        </div>
        <div className="text-5xl text-white uppercase font-[roboto] py-5 tracking-widest text-center">
          {bannerContent.mainText || "We love"} <span className="text-[#ffd615]">{bannerContent.highlightedText || "God,"}</span> {bannerContent.subText || "we"}
          <br />
          {bannerContent.bottomText || "beleive in god"}{" "}
        </div>
        <div className="text-white font-[roboto] py-5 text-xl text-center">
          {bannerContent.description || "Evangelical Friends Church in Rwanda is a faith-based organization that began its ministry in 1986 and was officially incorporated in 1987 in Kigali. It was founded through the efforts of missionaries from the American, Willard Ferguson and his wife Doris Ferguson, who, together with Rwandan believers, started preaching the gospel. The church emphasizes both spiritual growth and community transformation through initiatives such as education, poverty reduction, and other socio-economic programs. Over the years, the Evangelical Friends Church in Rwanda has expanded significantly, now comprising 76 local churches and operating throughout all regions of the country, with a membership of over 7,000. Church has also made a meaningful contribution to the holistic transformation and reconciliation of Rwandan society."}
        </div>
        <div className="flex gap-x-4">
          <button className="bg-[#ffd615] text-white rounded-full px-5 py-2 w-fit">
            {bannerContent.primaryButtonText || "Be part of use"}
          </button>
          <button className="text-[#ffd615] border border-yellow-500 rounded-full px-5 py-2">
            {bannerContent.secondaryButtonText || "Read more"}
          </button>
        </div>
      </div>
      <Navbar/>
    </div>
  );
};

export default SlidingImages;
